import { inject, InjectionToken, Provider } from '@angular/core';
import { submissionTypesSignalStore } from './signal-stores/submission-types.signal-store';
import { SubmissionTypesAdminSignalState } from '../types/submission-types-admin.types';

/**
 * Injection token for the submission types admin signal store
 */
export const SUBMISSION_TYPES_TOKEN =
  new InjectionToken<SubmissionTypesAdminSignalState>(
    'Submission Types Admin Signal Store',
  );

/**
 * Provider for the submission types admin signal store
 */
export const SUBMISSION_TYPES_PROVIDER: Provider = {
  provide: SUBMISSION_TYPES_TOKEN,
  useClass: submissionTypesSignalStore,
};

/**
 * Submission Types Admin Tokenizer - provides the submission types admin signal store instance
 */
export function submissionTypesTokenizer() {
  return inject(SUBMISSION_TYPES_TOKEN);
}

/**
 * Type definition for the submission types admin tokenizer
 */
export type submissionTypesTokenizer = ReturnType<
  typeof submissionTypesTokenizer
>;
